import { useContext, useEffect, useState } from 'react';

// material-ui
import { useTheme } from '@mui/material/styles';
import { Avatar, Box, useMediaQuery } from '@mui/material';

import AzureMSALContext from 'contexts/AzureMSALContext';

// project imports
import LogoSection from '../LogoSection';
import SearchSection from './SearchSection';
import MobileSection from './MobileSection';
import ProfileSection from './ProfileSection';
import LocalizationSection from './LocalizationSection';
import NotificationSection from './NotificationSection';
import { useDispatch, useSelector } from 'store';
import { openDrawer } from 'store/slices/menu';

// assets
import { IconMenu2 } from '@tabler/icons';

import { APP_ENV_HEADER_LABEL } from '../../../config';
import Enums from 'utils/Enums'

// ==============================|| MAIN NAVBAR / HEADER ||============================== //

const Header = () => {
    const theme = useTheme();

    const dispatch = useDispatch();
    const { drawerOpen } = useSelector((state) => state.menu);
    const [siteName, setSiteName] = useState("");
    const { SiteName } = Enums();
    const { userSite } = useContext(AzureMSALContext);

    let breakpoint = '';
    const matchDownXs = useMediaQuery(theme.breakpoints.down('xs'));
    const matchDownSm = useMediaQuery(theme.breakpoints.down('sm'));
    const matchDownMd = useMediaQuery(theme.breakpoints.down('md'));
    const matchDownLg = useMediaQuery(theme.breakpoints.down('lg'));
    const matchDownXl = useMediaQuery(theme.breakpoints.down('xl'));
    const matchDownXxl = useMediaQuery(theme.breakpoints.down('xxl'));
    const matchDownXxxl = useMediaQuery(theme.breakpoints.down('xxxl'));

    useEffect(() => {
        if(SiteName[userSite]){
            setSiteName(SiteName[userSite]);
        }
    },[userSite]);

    if (matchDownXs) breakpoint = 'xs';
    else if (matchDownSm) breakpoint = 'sm';
    else if (matchDownMd) breakpoint = 'md';
    else if (matchDownLg) breakpoint = 'lg';
    else if (matchDownXl) breakpoint = 'xl';
    else if (matchDownXxl) breakpoint = 'xxl';
    else if (matchDownXxxl) breakpoint = 'xxxl';

    return (
        <>
            {/* logo & toggler button */}
            <Box
                sx={{
                    width: 228,
                    display: 'flex',
                    [theme.breakpoints.down('md')]: {
                        width: 'auto'
                    }
                }}
            >
                <Box component="span" sx={{ display: { xs: 'none', md: 'block' }, flexGrow: 1 }}>
                    <LogoSection />
                </Box>
                <Avatar
                    variant="rounded"
                    sx={{
                        ...theme.typography.commonAvatar,
                        ...theme.typography.mediumAvatar,
                        overflow: 'hidden',
                        transition: 'all .2s ease-in-out',
                        background: theme.palette.mode === 'dark' ? theme.palette.dark.main : theme.palette.secondary.light,
                        color: theme.palette.mode === 'dark' ? theme.palette.secondary.main : theme.palette.secondary.dark,
                        '&:hover': {
                            background: theme.palette.mode === 'dark' ? theme.palette.secondary.main : theme.palette.secondary.dark,
                            color: theme.palette.mode === 'dark' ? theme.palette.secondary.light : theme.palette.secondary.light
                        }
                    }}
                    onClick={() => dispatch(openDrawer(!drawerOpen))}
                    color="inherit"
                >
                    <IconMenu2 stroke={1.5} size="1.3rem" />
                </Avatar>
            </Box>

            {/* header search */}
            <Box sx={{ flexGrow: 1 }} />
            <Box sx={{ flexGrow: 1 }} />
            <Box sx={{ flexGrow: 1.5 }}>
                <h1 className='text-center'>{`${APP_ENV_HEADER_LABEL} ${siteName}`}</h1>
            </Box>

            {/* live customization & localization */}
            <Box sx={{ display: { xs: 'none', sm: 'block' } }}>
                <LocalizationSection />
            </Box>

            {/* notification & profile */}
            <ProfileSection />

            {/* mobile header */}
            <Box sx={{ display: { xs: 'block', sm: 'none' } }}>
                <MobileSection />
            </Box>
        </>
    );
};

export default Header;
